module.exports = __webpack_public_path__ + "static/slide5-b7afc03ae2531bcce26bf7197de1f09e.jpg";